import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Landing from "../views/Landing.vue";
import Dashboard from '../views/Dashboard.vue';
import Programme from '../views/Programme.vue';
import Announcements from '../views/Announcements';
//import Notifications from '../views/Notifications';

import Store from '../store/index.js';

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "landing",
    component: Landing
  },
  {
    path: "/admin",
    name: "admin",
    component: Home
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard
  },
  {
    path: '/programme',
    name: 'programme',
    component: Programme
  },
  {
    path: '/announcements',
    name: 'announcements',
    component: Announcements
  },
  // {
  //   path: '/notification',
  //   name: 'notifications',
  //   component: Notifications
  // },
  {
    path: '*',
    redirect: '/'
  }
];

const router = new VueRouter({
  routes,
  linkActiveClass: 'active',
  mode: 'history'
});

router.beforeEach((to, from, next) => {
  const user = Store.state.user;
  if (to.name == 'landing') {
    Store.dispatch("setNav", false);
  } else {
    Store.dispatch("setNav", true);
  }

  if ((to.name != 'landing' && to.name != 'admin') && (!user || Object.keys(user).length === 0)) {
    next({ name: 'admin' });
  } else {
    next();
  }
})

export default router;
